<script>
import Button from "@/components/Button";
import bus from "@/bus";
import { useConsentStore } from "../../stores/consent";
import { useResourcesStore } from "../../stores/resources";

export default {
  setup() {
    const consentStore = useConsentStore();
    const resourcesStore = useResourcesStore();
    return {
      consentStore,
      resourcesStore,
    }
  },
  components: {
    Button,
  },
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      checked: false,
    };
  },
  methods: {
    async confirm() {
      const { import_data_id } = this.params;
      this.consentStore.set();
      await this.resourcesStore.downloadTownFile({ import_data_id })

      bus.emit("closeModal");
    },
  },
};
</script>

<template>
  <div class="p-8 z-50 bg-white shadow-xl rounded lg:min-w-xl lg:max-w-xl">
    <p class="mb-4">
      <input v-model="checked" type="checkbox" class="mt-2" />
      <span class="leading-snug">
        {{ $t("views.modals.terms_consent.terms.1") }}<br /><br />
        {{ $t("views.modals.terms_consent.terms.2") }}<br /><br />
        {{ $t("views.modals.terms_consent.terms.3") }}<br /><br />
        {{ $t("views.modals.terms_consent.terms.4") }}<br /><br />
        {{ $t("views.modals.terms_consent.terms.5") }}
      </span>
    </p>
    <Button :disabled="!checked" @click="confirm">
      {{ $t("views.modals.terms_consent.understand") }}
    </Button>
  </div>
</template>
